import { gql } from '@apollo/client';

export const SECURE_SUBSCRIBER_DOWNLOAD_QUERY = gql`
  query secureSubscriberDownload($format: SubscriberDownloadReportFormatEnum!, $slug: String!) {
    secureSubscriberDownload(format: $format, slug: $slug) {
      url
      filename
      downloadMessage
    }
  }
`;
